import PropTypes from 'prop-types';

export const referralInfoPropType = PropTypes.shape({
  isReferral: PropTypes.bool,
  isAffiliate: PropTypes.bool,
  referrerName: PropTypes.string,
  photoUrl: PropTypes.string,
  pl: PropTypes.shape({
    id: PropTypes.string,
    pro: PropTypes.string,
    plus: PropTypes.string,
    basic: PropTypes.string,
    type: PropTypes.string,
  }),
  code: PropTypes.string,
});

export const referralInfoContextPropType = {
  referralInfoContext: PropTypes.shape({
    referralInfo: referralInfoPropType,
  }),
};

export const referralInfoContextDefaultProp = {
  referralInfoContext: {
    referralInfo: undefined,
  },
};
